/**
 * Mission Data Adapter — the SINGLE boundary between storage and scoring.
 *
 * Reads mission KPI instances from the in-memory config store (populated
 * from the API via useApiKpiConfigs).
 *
 * Follows the same pattern as scheduleDataAdapter.ts and budgetDataAdapter.ts.
 */

import {
  getProjectKpiConfigOverride,
  type SubKpiInstance,
} from "../Data/ProjectConfig/projectKpiConfigOverrides";

// ---------------------------------------------------------------------------
// Config reads
// ---------------------------------------------------------------------------

/**
 * Read the SubKpiInstance[] config for a project's Mission category
 * from the in-memory config store (API-backed).
 */
export function getMissionInstancesFromStorage(
  projectGuid: string,
): SubKpiInstance[] {
  const pg = String(projectGuid || "").trim();
  if (!pg) return [];
  const cfg = getProjectKpiConfigOverride(pg as any);
  return Array.isArray(cfg?.category_instances?.mission)
    ? cfg!.category_instances!.mission!
    : [];
}

/**
 * Check whether a project has any mission KPI instances configured.
 * Useful for gating UI (empty state vs data entry).
 */
export function hasMissionInstances(projectGuid: string): boolean {
  return getMissionInstancesFromStorage(projectGuid).length > 0;
}
